"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function () {
    return _common.MARKING_TYPE;
  }
});
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _Loader = require("b2b-components/theme/components/Loader");
var _classnames = _interopRequireDefault(require("classnames"));
var _common = require("../common");
require("./Label.scss");
const Label = _ref => {
  let {
    children,
    className,
    htmlFor,
    onClick,
    markingType = _common.MARKING_TYPE.none,
    text = {
      required: '*',
      optional: '(optional)'
    },
    disabled = false,
    isAutoSave,
    isAutoSaveSuccess
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Label', {
    'cds-Label--Disabled': disabled
  }, className);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: rootClassName,
    htmlFor: htmlFor,
    onClick: onClick
  }, children, markingType === _common.MARKING_TYPE.required && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Label-Required"
  }, text.required), markingType === _common.MARKING_TYPE.optional && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Label-Optional"
  }, text.optional), (isAutoSave || isAutoSaveSuccess) && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Label-LoaderContainer"
  }, isAutoSave && /*#__PURE__*/_react.default.createElement(_Loader.Loader, {
    styleType: _Loader.LOADER_STYLE_TYPE.inline,
    className: "cds-Label-Loader"
  }), isAutoSaveSuccess && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-Label-SuccessIcon",
    name: _Icon.ICON_NAME.checkmark,
    size: _Icon.ICON_SIZE.xsmall
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Label-AutoSaveText",
    role: "status"
  }, text.autoSave)));
};
exports.Label = Label;
//# sourceMappingURL=Label.js.map